
import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

interface SearchFieldProps {
  value: string;
  error: boolean | string;
  setValue: (value: string) => void;
  setError: (error: boolean | string) => void;
  onSubmit: () => void;
  [key: string]: unknown;
}

export default function SearchField({
  value,
  error,
  setValue,
  setError,
  onSubmit,
  ...rest
}: SearchFieldProps): React.JSX.Element {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value: newValue } = event.target;
    setValue(newValue);
    if (newValue === '') {
      setError('Search cannot be blank');
    } else {
      setError(false);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.which === 13) {
      //<------use enter key to submit form
      event.preventDefault();
      onSubmit();
    }
  };

  return (
    <Box>
      <FormControl fullWidth>
        <TextField
          {...rest}
          label='Search'
          id='search'
          aria-describedby='search-helper-text'
          onChange={handleChange}
          error={Boolean(error)}
          onKeyDown={handleKeyDown}
          value={value}
          variant='standard'
          multiline
        />
        {error ? (
          <FormHelperText id='search-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='search-helper-text'>
            Enter a short phrase that will identify the document you wish to
            audit.
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}

